import React, { useState, useEffect } from 'react';
import { AboutCard } from '../../components/Cards';
import styled from 'styled-components';
import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';
import { client } from '../../Sanityclient';
const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
`;
const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';
    client
      .fetch(query)
      .then((data) => {
        console.log(data);
        setAbouts(data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <h2 className="head-text">
        I Know that <span>Creative Frontend & Efficient Backend </span> <br />
        Makes It Possible to Build <span>Good Productive Apps</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <CardContainer key={index}>
            <AboutCard about={about} />
          </CardContainer>
        ))}
      </div>
    </>
  );
};
export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);
